import { Component, OnInit, Input, ContentChild , ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { Observable, of } from "rxjs";
import { NumberFormatStyle } from "@angular/common";
import { IndexKind } from "typescript";
import { prependListener } from "process";

 
interface Shape {
  expand: number;
  angle: number;
}

@Component({
  selector: "artbycoloring-canvas",
  templateUrl: "./canvas.component.html",
  styleUrls: ["./canvas.component.css"]
})

export class CanvasComponent implements OnInit {

  event: PointerEvent;
  clientX = 0;
  clientY = 0;
  sliderArray = [];
  selectedArray = [];

  onEvent(event: PointerEvent): void {
    this.event = event;
  }

  coordinates(event: PointerEvent): void {
    this.clientX = event.clientX;
    this.clientY = event.clientY;
    if (this.clientX < 1250) {
      this.basementX = Math.round( (1250-event.clientX)*-4);
    }
    else if (this.clientX > 1250) {
      this.basementX = Math.round( (event.clientX-1250)*4);
    }
     
    
    if (this.clientY < 450) {
            this.basementY = Math.round( (450-event.clientY)*-4);
    }
    else if (this.clientY > 450) {
            this.basementY = Math.round( (event.clientY-450)*4);
    }
    
  }
  @Input()

  aLayers: number;
  all: number[];
  alpha: number;
  alphap: string;
  Arr = Array; //Array type captured in a variable
  artData: string;
  artplace: string;
  ascale: string;
  ascaleit: number;
  ascaleitString: string;
  ascaleitValue: number;
  ascaleX: number;
  ascalex: string;
  ascaleXString: string;
  ascaleXValue: number;
  ascaleY: number;
  ascaley: string;
  ascaleYString: string;
  ascaleYValue: number;
  askewX: number;
  askewx: string;
  askewXString: string;
  askewXValue: number;
  askewY: number;
  askewy: string;
  askewYString: string;
  askewYValue: number;
  astart: string;
  atype: string;
  avalues: string;
  backg: number;
  backgAlpha: Number;
  backgColorString: string;
  backgHue: Number;
  backgSat: Number;
  backgVal: Number;
  base: string;
  basement: string;
  basement1: boolean;
  basementX: number;
  basementY: number;
  basemoveh: any;
  basemovev: any;
  baserotate: any;
  basescale: any;
  basescaleX: any;
  basescaleY: any;
  baseskewX: any;
  baseskewY: any;
  baseuse: boolean;
  centx: number;
  centy: number;
  changeit: any;
  click: boolean
  clickX: number;
  clickY: number;
  closecurve: boolean;
  codestring: string;
  codestorage: string;
  colorNumber: number;
  colors: any;
  colorString: any;
  counter: number;
  cskax: number;
  cskay: number;
  currentColor: String;
  currentFill: String;
  cx: number;
  cy: number;
  default: number;
  deltak: number;
  deltal: number;
  deltam: number;
  direction: String;
  duplicateShape: boolean;
  durspeed: number;
  endaddress: string;
  endAlpha: number;
  endBackground: number;
  endFreeze: number;
  endHorizontal: number;
  endHue: number;
  endLayers: number;
  endRotate: number;
  endSat: number;
  endScale: number;
  endScaleX: number;
  endScaleY: number;
  endSkewX: number;
  endSkewY: number;
  endspeed: number;
  endSpread: number;
  endsteps: number;
  endStop: number;
  endStrokeColor: number;
  endStrokeWidth: number;
  endVal: number;
  endVertical: number;
  endZoom: number;
  factor: Array<string>;
  factors: Array<string>;
  factorvalue: Array<string>;
  file: any;
  filenamein: string;
  filenameout: string;
  fileShape: string = "fileShape";
  fillColorString: string;
  garage: string;
  garage1: boolean;
  hue: number;
  huep: string;
  i: number;
  iexpand: number;
  ifAlpha: boolean;
  ifBa: boolean;
  ifbackground: boolean;
  ifFo: boolean;
  ifFreeze: boolean;
  ifGa: boolean;
  ifHorizontal: boolean;
  ifHue: boolean;
  ifKi: boolean;
  ifLayers: boolean;
  ifmovies: boolean;
  ifreadartdata: boolean;
  ifRotate: boolean;
  ifS1: boolean;
  ifS2: boolean;
  ifS3: boolean;
  ifSat: boolean;
  ifScale: boolean;
  ifScaleX: boolean;
  ifScaleY: boolean;
  ifSkewX: boolean;
  ifSkewY: boolean;
  ifspeed: boolean;
  ifSpread: boolean;
  ifsteps: boolean;
  ifStrokeColor: boolean;
  ifStrokeWidth: boolean;
  iftools: boolean;
  ifVal: boolean;
  ifVertical: boolean;
  ifZoom: boolean;
  iLayers: number;
  imove: number;
  imoveh: number;
  imovehString: string;
  imovehValue: number;
  imovev: number;
  imovevString: string;
  imovevValue: number;
  incAlpha: number;
  incBackground: number;
  incFreeze: number;
  incHorizontal: number;
  incHue: number;
  incLayers: number;
  incRotate: number;
  incSat: number;
  incScale: number;
  incScaleX: number;
  incScaleY: number;
  incSkewX: number;
  incSkewY: number;
  incspeed: number;
  incSpread: number;
  incsteps: number;
  incStop: number;
  incStrokeColor: number;
  incStrokeWidth: number;
  incVal: number;
  incVertical: number;
  incZoom: number;
  info: Array<string>;
  irock: number;
  irotate: number;
  irotateString: string;
  iscale: number;
  iscaleit: number;
  iscaleitString: string;
  iscaleitValue: number;
  iscaleString: string;
  iscaleValue: number;
  iscaleX: number;
  iscaleXString: string;
  iscaleXValue: number;
  iscaleY: number;
  iscaleYString: string;
  iscaleYValue: number;
  iskewX: number;
  iskewXString: string;
  iskewXValue: number;
  iskewY: number;
  iskewYString: string;
  iskewYValue: number;
  item: string;
  itransformString: string;
  itranslateString: string;
  kitchen: string;
  kitchen1: boolean;
  lastMoveX: number;
  lastMoveY: number;
  layers: number;
  layerssize: boolean;
  lockbackg: boolean;
  lockscale: boolean;
  lockShape: boolean;
  lockzoom: boolean;
  maxx: number;
  maxy: number;
  middys: string;
  minx: number;
  miny: number;
  modifyit: Array<number>;
  moveShape: boolean;
  moveX: number;
  moveY: number;
  myaction: string;
  myboundinbgbox: string;
  mybox: HTMLElement;
  mycenter: string;
  mycentered: string;
  myclose: string;
  mycolor: string;
  mycontainer: any;
  mycurve: string;
  mydisplay: string;
  myend: string;
  myFreeze: number;
  mygroup: boolean;
  myif: string;
  mymirror: string;
  myname: string;
  mynum: number;
  myout: string;
  myplace: string;
  mypoly: string;
  myscalex: boolean;
  myscaley: boolean;
  myshape: any;
  mysteps: number;
  myStop: number;
  mysvgfile: string;
  mytoken: string;
  myvalues: string;
  newbase: string;
  newDemo: string;
  newName: string;
  newProject: string;
  newshape: string = "scribble";
  nlength: number;
  numberShapes: number;
  numpnt: string;
  objectData: string;
  offset: any;
  output: any;
  outbase: any;
  outdata: string;
  outputSpeedString: string;
  outputSpreadString: string;
  paletteColor: string;
  paletteString: string;
  part1: string;
  part2: string;
  partslength: number;
  partsString: string[];
  partsValue: number[];
  pasteArtDataString: string;
  pasteImagecodeString: string;
  pastePaletteString: string;
  pasteSVGcodeString: string;
  playspace: any;
  plength: number;
  polyshape: string = "polyshape";
  presetsbox: boolean;
  qshape: string;
  randomAlphaValue: boolean;
  randomartdata: string;
  randomColor: boolean;
  randomHueValue: boolean;
  randomHValue: boolean;
  randomLayers: boolean;
  randomRotateValue: boolean;
  randomSatValue: boolean;
  randomScaleValue: boolean;
  randomSkewXValue: boolean;
  randomSkewYValue: boolean;
  randomString: string;
  randomStrokeColorValue: boolean;
  randomStrokeWidthValue: boolean;
  randomValValue: boolean;
  randomVValue: boolean;
randomsvgyy0: boolean;
randomsvgyy1: boolean;
randomsvgyy2: boolean;
randomsvgyy3: boolean;
randomsvgyy4: boolean;
randomsvgyy5: boolean;
randomsvgyy6: boolean;
randomsvgyy7: boolean;
randomsvgyy8: boolean;
randomsvgyy9: boolean;
randomsvgyy10: boolean;
randomsvgyy11: boolean;
randomsvgxx0: boolean;
randomsvgxx1: boolean;
randomsvgxx2: boolean;
randomsvgxx3: boolean;
randomsvgxx4: boolean;
randomsvgxx5: boolean;
randomsvgxx6: boolean;
randomsvgxx7: boolean;
randomsvgxx8: boolean;
randomsvgxx9: boolean;
randomsvgxx10: boolean;
randomsvgxx11: boolean;


  re: any
  rememberArtData: string;
  rgbColor: string;
  roman: string = "roman";
  rorx: number;
  rory: number;
  rotateString: string;
  rotateValue: number;
  sat: number;
  satp: string;
  scale: number;
  scaleString: string;
  selectedColor: any;
  selectedElement: boolean;
  selectedMyElement: any;
  shape: string;
  shapeArray = Array;
  shapecode: string;
  shapeData: string;
  shapeID: string;
  shapeName: string;
  shapes: Observable<Shape[]>;
  showArtData: boolean = false;
  showcurve:string;
  showData: string;
  showShape: boolean = false;
  showsvgData: boolean = false
  skax: number;
  skay: number;
  skewXString: string;
  skewXValue: number;
  skewYString: string;
  skewYValue: number;
  slideAlpha: boolean;
  slidebackground: boolean;
  slideFreeze: boolean;
  slideHorizontal: boolean;
  slideHue: boolean;
  slideLayers: boolean;
  slider: any;
  slideRotate: boolean;
  slideSat: boolean;
  slideScale: boolean;
  slideScaleX: boolean;
  slideScaleY: boolean;
  slideSkewX: boolean;
  slideSkewY: boolean;
  slideSpread: boolean;
  slideStrokeColor: boolean;
  slideStrokeWidth: boolean;
  slideVal: boolean;
  slideVertical: boolean;
  slideZoom: boolean;
  spreadsize: number;
  sskax: number;
  sskay: number;
  stageHalf: number;
  stageSize: number;
  startaddress: string;
  startAlpha: number;
  startBackground: number;
  startFreeze: number;
  startHorizontal: number;
  startHue: number;
  startLayers: number;
  startmarker: string;
  startRotate: number;
  startSat: number;
  startScale: number;
  startScaleX: number;
  startScaleY: number;
  startSkewX: number;
  startSkewY: number;
  startspeed: number;
  startSpread: number;
  startsteps: number;
  startStop: number;
  startStrokeColor: number;
  startStrokeWidth: number;
  startVal: number;
  startVertical: number;
  startZoom: number;
  stopmyarray: boolean;
  stopmyslide: boolean;
  stroke: number;
  strokeAlpha: Number;
  strokeColorString: string;
  strokeHue: Number;
  strokeSat: Number;
  strokeString: string;
  strokeVal: Number;
  strokeWidth: Number;
  strokeWidthString: string;
  svg: any;
  svgheight: string;
  svgstage: string;
  svgviewbox: string;
  svgwidtth: string;
  svgx: string;
  svgy: string;
  thing: string;
  tom: any;
  transform: any;
  transformString: string;
  translateHValue: number;
  translateString: string;
  translateVValue: number;
  tskax: number;
  typetextString: string;
  useArtObjectsbox: boolean;
  usecontainersbox: boolean;
  usepalettebox: boolean;
  usepresetsbox: boolean;
  val: number;
  valp: string;

  xlist: number[];
  xx: number[];

  ylist: number[];
  yourname: string;
  yy: number[];
  zoomsize: Number;
  codeline: any;
  curvestring: string
  curvecode: string
outputyy0: any;
outputyy1: any;
outputyy2: any;
outputyy3: any;
outputyy4: any;
outputyy5: any;
outputyy6: any;
outputyy7: any;
outputyy8: any;
outputyy9: any;
outputyy10: any;
outputyy11: any;
outputxx0: any;
outputxx1: any;
outputxx2: any;
outputxx3: any;
outputxx4: any;
outputxx5: any;
outputxx6: any;
outputxx7: any;
outputxx8: any;
outputxx9: any;
outputxx10: any;
outputxx11: any;

xx0: number;
xx1: number;
xx2: number;
xx3: number;
xx4: number;
xx5: number;
xx6: number;
xx7: number;
xx8: number;
xx9: number;
xx10: number;
xx11: number;
yy0: number;
yy1: number;
yy2: number;
yy3: number;
yy4: number;
yy5: number;
yy6: number;
yy7: number;
yy8: number;
yy9: number;
yy10: number;
yy11: number;

svgxx0: number;
svgxx1: number;
svgxx2: number;
svgxx3: number;
svgxx4: number;
svgxx5: number;
svgxx6: number;
svgxx7: number;
svgxx8: number;
svgxx9: number;
svgxx10: number;
svgxx11: number;
svgyy0: number;
svgyy1: number;
svgyy2: number;
svgyy3: number;
svgyy4: number;
svgyy5: number;
svgyy6: number;
svgyy7: number;
svgyy8: number;
svgyy9: number;
svgyy10: number;
  svgyy11: number;
  polycode: string;
  bezcode: string;
  quadcode: string;
  constructor () {
    
  }

  ngOnInit() {
    var mybox = document.getElementById("playspace");
    mybox.addEventListener("click", this.polyit);
    this.shapes = of([
      {
        id: 1,
        iterations: 18,
        angle: 15,
        expand: 47
      },
      {
        id: 2,
        iterations: 36,
        angle: 11,
        expand: 33
      }
    ]);
    this.setValues();
    this.svgstage = this.convertStageSize(this.stageSize);
    this.selectedColor = {
      r: 100,
      g: 130,
      b: 150,
      a: this.alpha
    }
    this.irotate = 0;
    this.imove = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.iscale = 1;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    this.irotate = 0;

    
  }

  private setValues() {
    this.aLayers = 360;
    this.all = [this.irotate, this.iscaleX, this.iscaleY, this.iskewX, this.iskewY, this.imoveh, this.imovev];
    this.alpha = 1;
    this.alphap = "1";
    this.artData = "";
    this.artplace = "";
    this.ascale;
    this.ascaleit = 0;
    this.ascaleitString = "0";
    this.ascaleitValue = 0;
    this.ascaleX = 0.9;
    this.ascalex;
    this.ascaleXString = "0.9";
    this.ascaleXValue = 0.9;
    this.ascaleY = 0.9;
    this.ascaley;
    this.ascaleYString = "0.9";
    this.ascaleYValue = 0.9;
    this.askewX = 20;
    this.askewx;
    this.askewXString = "20";
    this.askewXValue = 20;
    this.askewY = 20;
    this.askewy;
    this.askewYString = "20";
    this.askewYValue = 20;
    this.atype = "rotate";
    this.avalues = "0\;360";
    this.backg = 0;
    this.backgAlpha = 1;
    this.backgColorString = "0";
    this.backgHue = 360;
    this.backgSat = 100;
    this.backgVal = 100;
    this.base = "";
    this.basement = ""
    this.basement1 = false;
    this.basementX = this.clientX - 1250;
    this.basementY = this.clientY - 450;
    this.basemoveh = 0;
    this.basemovev = 0;
    this.baserotate = 0;
    this.basescale = 1;
    this.basescaleX = 1;
    this.basescaleY = 1;
    this.baseskewX = 0;
    this.baseskewY = 0;
    this.baseuse = false;
    this.centx = 0;
    this.centy = 0;
    this.click = false;
    this.clickX = 0;
    this.clickY = 0;
    this.closecurve = false;
    this.codestorage="";
    this.colorNumber = 0;
    this.colors = Array;
    this.colorString = Array;
    this.counter = 0;
    this.cskax = 0;
    this.cskay = 0;
    this.currentColor = "#F0F0F0FF";
    this.currentFill = "";
    this.cx = 0;
    this.cy = 0;
    this.default = 1;
    this.deltak = 0;
    this.deltal = 0;
    this.deltam = 0;
    this.direction = "";
    this.duplicateShape = false;
    this.durspeed = 20;
    this.endaddress = '"></image>';
    this.endAlpha = 1;
    this.endBackground = 360;
    this.endFreeze = 0;
    this.endFreeze = 0;
    this.endHorizontal = 300;
    this.endHue = 360;
    this.endLayers = 360;
    this.endRotate = 360;
    this.endSat = 0;
    this.endScale = 4;
    this.endScaleX = 3;
    this.endScaleY = 4;
    this.endSkewX = 80;
    this.endSkewY = 60;
    this.endSpread = 200;
    this.endStop = 1;
    this.endStrokeColor = 360;
    this.endStrokeWidth = 15;
    this.endVal = 100;
    this.endVertical = 200;
    this.endZoom = this.layers;
    this.factor = [];
    this.factors;
    this.factorvalue;
    this.filenamein = "art.txt";
    this.filenameout = "art.txt";
    this.garage = '<polygone points="0,0 200.0 0,20>';
    this.garage1 = false;
    this.hue = 10;
    this.huep = "0";
    this.iexpand = 4;
    this.ifAlpha = false;
    this.ifBa = false;
    this.ifbackground = false;
    this.ifFo = false;
    this.ifFreeze = false;
    this.ifGa = false;
    this.ifHorizontal = false;
    this.ifHue = false;
    this.ifKi = false;
    this.ifLayers = false;
    this.ifmovies = false;
    this.ifreadartdata = false;
    this.ifRotate = false;
    this.ifS1 = false;
    this.ifS2 = false;
    this.ifS3 = false;
    this.ifSat = false;
    this.ifScale = false;
    this.ifScaleX = false;
    this.ifScaleY = false;
    this.ifSkewX = false;
    this.ifSkewY = false;
    this.ifspeed = false;
    this.ifSpread = false;
    this.ifsteps = false;
    this.ifStrokeColor = false;
    this.ifStrokeWidth = false;
    this.iftools = false;
    this.ifVal = false;
    this.ifVertical = false;
    this.ifZoom = false;
    this.iLayers = 360;
    this.imove = 0;
    this.imoveh = 0;
    this.imovehString = "100";
    this.imovehValue = 100;
    this.imovev = 0;
    this.imovevString = "100";
    this.imovevValue = 0;
    this.incAlpha = 0.1;
    this.incBackground = 0;
    this.incFreeze = 0;
    this.incFreeze = 0;
    this.incHorizontal = 0;
    this.incHue = 11;
    this.incLayers = 1;
    this.incRotate = 5;
    this.incSat = 0;
    this.incScale = 0.1;
    this.incScaleX = 0.1;
    this.incScaleY = 0.1;
    this.incSkewX = 0;
    this.incSkewY = 0;
    this.incSpread = 0;
    this.incStop = 1;
    this.incStrokeColor = 0;
    this.incStrokeWidth = 1;
    this.incVal = 0;
    this.incVertical = 0;
    this.incZoom = 1;
    this.info = [""];
    this.irotate = 0;
    this.irotateString = "360";
    this.iscale = 1;
    this.iscaleString = "0";
    this.iscaleValue = 0;
    this.iscaleX = 1;
    this.iscaleXString = "0.9";
    this.iscaleXValue = 0.9;
    this.iscaleY = 1;
    this.iscaleYString = "0.9";
    this.iscaleYValue = 0.9;
    this.iskewX = 0;
    this.iskewXString = "20";
    this.iskewXValue = 20;
    this.iskewY = 0;
    this.iskewYString = "20";
    this.iskewYValue = 20;
    this.item = "";
    this.kitchen = '<rect x=" 0" y="0" width="300" height="100"></rect>';
    this.kitchen1 = false;
    this.lastMoveX = 0;
    this.lastMoveY = 0;
    this.layers = 40;
    this.layerssize = false;
    this.lockbackg = false;
    this.lockscale = true;
    this.lockShape = false;
    this.maxx = 0;
    this.maxy = 0;
    this.middys = "";
    this.minx = 0;
    this.miny = 0;
    this.moveShape = true;
    this.moveX = 0;
    this.moveY = 0;
    this.myaction = "rotate";
    this.myboundinbgbox = "";
    this.mycenter = "";
    this.mycentered = "";
    this.myclose = 'z"\>\</path\>';
    this.mycolor = "";
    this.mycontainer = "kitchen";
    this.mycurve = '<path class="draggable" d=" ';
    this.mydisplay = "";
    this.myFreeze = 0;
    this.mygroup = false;
    this.myif = "ifrotate";
    this.mymirror = "";
    this.myname = "basement";
    this.mynum = 0;
    this.myout = "";
    this.myplace = "#" + this.myname;
    this.mypoly = "";
    this.myscalex = false;
    this.myscaley = false;
    this.myshape = "<line 0,0 700,700 />";
    this.mysteps = 30;
    this.myStop = 1;
    this.mysvgfile = "";
    this.mytoken = "Ba";
    this.myvalues = "360";
    this.newbase = "";
    this.newDemo = "demoDemo";
    this.newName = "";
    this.nlength = 0;
    this.numberShapes = 5;
    this.numpnt = "";
    this.objectData = "";
    this.offset = 0;
    this.outdata = "";
    this.outputSpeedString = "1s";
    this.outputSpreadString = "rotate(0,0,0) scale(1,1) skewX(0) skewY(0) translate(0,0)";
    this.paletteColor = "10,100,100,1";
    this.paletteString = "";
    this.part1 = "";
    this.part2 = "";
    this.partslength = 0;
    this.partsString = [];
    this.partsValue = [];
    this.pasteArtDataString = "";
    this.pasteImagecodeString = '';
    this.pastePaletteString = "";
    this.pasteSVGcodeString = "";
    this.playspace = "";
    this.plength = 3;
    this.presetsbox = false;
    this.randomAlphaValue = false;
    this.randomartdata = "";
    this.randomColor = false;
    this.randomHueValue = false;
    this.randomHValue = false;
    this.randomLayers = false;
    this.randomRotateValue = false;
    this.randomSatValue = false;
    this.randomScaleValue = false;
    this.randomSkewXValue = false;
    this.randomSkewYValue = false;
    this.randomStrokeColorValue = false;
    this.randomStrokeWidthValue = false;
    this.randomValValue = false;
    this.randomVValue = false;
    this.randomsvgyy0=true;
this.randomsvgyy0 = true;
this.randomsvgyy1 = true;
this.randomsvgyy2 = true;
this.randomsvgyy3 = true;
this.randomsvgyy4 = true;
this.randomsvgyy5 = true;
this.randomsvgyy6 = true;
this.randomsvgyy7 = true;
this.randomsvgyy8 = true;
this.randomsvgyy9 = true;
this.randomsvgyy10 = true;
this.randomsvgyy11 = true;
this.randomsvgxx0 = true;
this.randomsvgxx1 = true;
this.randomsvgxx2 = true;
this.randomsvgxx3 = true;
this.randomsvgxx4 = true;
this.randomsvgxx5 = true;
this.randomsvgxx6 = true;
this.randomsvgxx7 = true;
this.randomsvgxx8 = true;
this.randomsvgxx9 = true;
this.randomsvgxx10 = true;
this.randomsvgxx11 = true;


    this.re = "";
    this.rememberArtData = "";
    this.rorx = 0;
    this.rory = 0;
    this.rotateValue = 3;
    this.sat = 100;
    this.satp = "100";
    this.scale = 0.05;
    this.selectedElement = false;
    this.selectedMyElement = null;
    this.shapeArray = Array;
    this.shapecode = "<>";
    this.shapeData = ""
    this.shapeID = "moon";
    this.shapeName = "#base";
    this.showData = "";
    this.showcurve ="";
    this.skax = 0;
    this.skay = 0;
    this.skewXValue = 0;
    this.skewYValue = 0;
    this.slideAlpha = false;
    this.slidebackground = false;
    this.slideFreeze = false;
    this.slideHorizontal = false;
    this.slideHue = false;
    this.slideLayers = false;
    this.slideRotate = false;
    this.slideSat = false;
    this.slideScale = false;
    this.slideScaleX = false;
    this.slideScaleY = false;
    this.slideSkewX = false;
    this.slideSkewY = false;
    this.slideSpread = false;
    this.slideStrokeColor = false;
    this.slideStrokeWidth = false;
    this.slideVal = false;
    this.slideVertical = false;
    this.slideZoom = false;
    this.spreadsize = 200;
    this.sskax = 0;
    this.sskay = 0;
    this.stageHalf = -250;
    this.stageSize = 500;
    this.startaddress = '<image  width="200" height="100" xlink: href="';
    this.startaddress = '<image  width="200" height="100" xlink: href="';
    this.startAlpha = 0.1;
    this.startBackground = 0;
    this.startFreeze = 0;
    this.startHorizontal = 0;
    this.startHue = 11;
    this.startLayers = 1;
    this.startRotate = 5;
    this.startSat = 0;
    this.startScale = 0.1;
    this.startScaleX = 0.1;
    this.startScaleY = 0.1;
    this.startSkewX = 0;
    this.startSkewY = 0;
    this.startSpread = 0;
    this.startStop = 1;
    this.startStrokeColor = 0;
    this.startStrokeWidth = 1;
    this.startVal = 0;
    this.startVertical = 0;
    this.startZoom = 1;
    this.stopmyarray = true;
    this.stopmyslide = true;
    this.stroke = 0;
    this.strokeAlpha = 1;
    this.strokeHue = 0;
    this.strokeSat = 100;
    this.strokeVal = 100;
    this.strokeWidth = 2;
    this.svg = null;
    this.svgheight = 'height="1000px"';
    this.svgstage = "";
    this.svgviewbox = 'viewBox="-500 -500 1000 1000"';
    this.svgwidtth = 'width="500px"';
    this.svgx = 'x="-500px"';
    this.svgy = 'y="-500px"';
    this.thing = "";
    this.transform = null;
    this.translateHValue = 0;
    this.translateVValue = 0;
    this.tskax = 0;
    this.typetextString = "";
    this.useArtObjectsbox = true;
    this.usecontainersbox = true;
    this.usepalettebox = false;
    this.usepresetsbox = true;
    this.val = 100;
    this.valp = "100";
this.xx0 = 0;
this.xx1 = 100;
this.xx2 = 500;
this.xx3 = 500;
this.xx4 = 500;
this.xx5 = 500;
this.xx6 = 500;
this.xx7 = 500;
this.xx8 = 500;
this.xx9 = 500;
this.xx10 = 500;
this.xx11 = 500;
this.yy0 = 0;
this.yy1 = 100;
this.yy2 = 100;
this.yy3 = 200;
this.yy4 = 500;
this.yy5 = 500;
this.yy6 = 500;
this.yy7 = 500;
this.yy8 = 500;
this.yy9 = 500;
this.yy10 = 500;
this.yy11 = 500;

    this.xlist = [];
    this.xx = [];
    this.ylist = [];
    this.yourname = "yourname";
    this.yy = [];
    this.zoomsize = 1;
    this.curvecode = "";

    this.svgxx0 = 0;
    this.svgyy0 = 0;

    this.svgxx1 = 100;
    this.svgyy1 = 100;
    
    this.svgxx2 = 200;
    this.svgyy2 = 100;

    this.svgxx3 = 300;
    this.svgyy3 = 0;

    this.svgxx4 = 100;
    this.svgyy4 = 100;

    this.svgxx5 = 250;
    this.svgyy5 = 300;

    this.svgxx6 = 400;
    this.svgyy6 = 200;

    this.svgxx7 = -100;
    this.svgyy7 = -300;

    this.svgxx8 = 0;
    this.svgyy8 = 0;

    this.svgxx9 = 600;
    this.svgyy9 = 200;

    this.svgxx10 = 100;
    this.svgyy10 = 100;

    this.svgxx11 = 100;
    this.svgyy11 = 100;

  }

  private setShape(shapeName) {
    this.shapeName = shapeName;
    this.shapeID = this.shapeName.replace(/#/, "");
    //this.shapeID = setShape(shapeName);
    return this.shapeID;
  }

  private outputBasement() {
    var r = this.irotate;
    var sc = this.iscale;
    var skx = this.iskewX;
    var sky = this.iskewY;
    var scx = this.iscaleX;
    var scy = this.iscaleY;
    var th = this.imoveh;
    var tv = this.imovev;
    var i = 1;
    if (this.lockscale == true) { this.iscaleString = "scale(" + sc + ", " + sc + ")"; }
    else if (this.lockscale == false) { this.iscaleString = "scale(" + scx + ", " + scy + ")"; }
    this.irotateString = "rotate(" + r + ",0,0)";
    //this.iscaleString = "scale(" + sc + ", " + sc + ")";
    this.iskewXString = "skewX(" + skx + ")";
    this.iskewYString = "skewY(" + sky + ")";
    this.itranslateString = "translate(" + th + "," + tv + ")";
    this.itransformString =
      this.irotateString +
      " " +
      this.iscaleString +
      " " +
      this.iskewXString +
      " " +
      this.iskewYString +
      " " +
      this.itranslateString;

    return this.itransformString;
  }

  private outputSpread(rotateValue, spreadsize) {
    this.outputSpreadString = "rotate(" + rotateValue + ",0,0) scale(1,1) skewX(0) skewY(0) translate(" + this.spreadsize + ", " + 0 + ")";
    return this.outputSpreadString;
  }
  
  private xoutputSpread(rotateValue, spreadsize) {
    var myangle = rotateValue;
    var pi = Math.PI;
    var myradians = myangle * Math.PI / 180;
    var x = spreadsize * Math.cos(myradians);
    var y = spreadsize * Math.sin(myradians);
  
    x = Math.floor(x);
    y = Math.floor(y);
    if (90 << myangle >> 0) {
      x = x + spreadsize;
      y = y + spreadsize;
    }
    if (180 << myangle >> 90) {
      x = -x - spreadsize;
      y = y + spreadsize;
    }
    if (270 << myangle >> 180) {
      x = -x - spreadsize;
      y = -y - spreadsize;
    }
    if (360 << myangle >> 270) {
      x = x + spreadsize;
      y = -y - spreadsize;
    }
    //console.log(x + "," + y);
    this.outputSpreadString = "rotate(" + rotateValue + ",0,0) scale(1,1) skewX(0) skewY(0) translate(" + x + "," + y + ")";
    //console.log(this.outputSpreadString);
    return this.outputSpreadString;
  }

  private setNumberShapes(numberShapesValue) {
    this.numberShapes = numberShapesValue;
  }

  private outputTransform(
    rotate,
    r,
    randomRotateValue,
    scale,
    s,
    randomScaleValue,
    skewX,
    sx,
    randomSkewXValue,
    skewY,
    sy,
    randomSkewYValue,
    translate,
    th,
    randomHValue,
    tv,
    randomVValue,
    i
  ) {

    if (rotate == "rotate") {
      if (this.randomRotateValue == true) {
        r = this.getRandom(1, 360);
      }
      this.rotateString = "rotate(" + r + ",0,0)";
    }
    if (scale == "scale") {
      if (this.randomScaleValue == true) {
        s = this.getRandom(1, 200) / 360;
        s = s.toFixed(2);
      }
      else {
        s = s.toFixed(2);
        this.scaleString = "scale(" + s + ", " + s + ")";
      }
    }
    if (skewX == "skewX") {
      if (this.randomSkewXValue == true) {
        sx = this.getRandom(1, 80);
      }
      this.skewXString = "skewX(" + sx + ")";
    }
    if (skewY == "skewY") {
      if (this.randomSkewYValue == true) {
        sy = this.getRandom(1, 80);
      }
      this.skewYString = "skewY(" + sy + ")";
    }
    if (translate == "translate") {
      if (randomHValue == true) {
        th = this.getRandom(-900, 900);
      }

      if (randomVValue == true) {
        tv = this.getRandom(-900, 900);
      }
      this.translateString = "translate(" + th + "," + tv + ")";
    }
    this.transformString =
      this.rotateString +
      " " +
      this.scaleString +
      " " +
      this.skewXString +
      " " +
      this.skewYString +
      " " +
      this.translateString;

    return this.transformString;
  }

  private hueWithWhite2rgba(otherHue) {
    if (otherHue <= 10) {
      this.strokeSat = 100;
      this.strokeVal = 0;
      this.strokeAlpha = 1;
    } else if (otherHue >= 350) {
      this.strokeSat = 0;
      this.strokeVal = 100;
      this.strokeAlpha = 1;
    } else {
      this.strokeSat = 100;
      this.strokeVal = 100;
      this.strokeAlpha = 1;
    }
    this.strokeColorString = this.hsv2rgba(
      otherHue,
      this.strokeSat,
      this.strokeVal,
      this.strokeAlpha
    );
    return this.strokeColorString;
  }

  private strokeWithWhite2rgba(stroke) {
    if (this.randomStrokeColorValue == true) {
      stroke = this.getRandom(10, 365);
    }
    if (stroke <= 10) {
      this.strokeSat = 100;
      this.strokeVal = 0;
      this.strokeAlpha = 1;
    } else if (stroke >= 350) {
      this.strokeSat = 0;
      this.strokeVal = 100;
      this.strokeAlpha = 1;
    } else {
      this.strokeSat = 100;
      this.strokeVal = 100;
      this.strokeAlpha = 1;
    }
    this.strokeColorString = this.hsv2rgba(
      stroke,
      this.strokeSat,
      this.strokeVal,
      this.strokeAlpha
    );
    return this.strokeColorString;
  }

  private backgWithWhite2rgba(backgHue) {
    if (backgHue <= 10) {
      this.backgSat = 100;
      this.backgVal = 0;
      this.backgAlpha = 1;
    } else if (backgHue >= 350) {
      this.backgSat = 0;
      this.backgVal = 100;
      this.backgAlpha = 1;
    } else {
      this.backgSat = 100;
      this.backgVal = 100;
      this.backgAlpha = 1;
    }
    this.backgColorString = this.hsv2rgba(
      backgHue,
      this.backgSat,
      this.backgVal,
      this.backgAlpha
    );
    return this.backgColorString;
  }

  private fillWithWhite2rgba(hue, sat, val, alpha) {
    this.counter++;
    //hue = hue % 360;
    if (this.randomHueValue == true) {
      hue = this.getRandom(0, 360);
    }
    if (this.randomSatValue == true) {
      sat = this.getRandom(0, 100);
    }
    if (this.randomValValue == true) {
      val = this.getRandom(20, 100);
    }
    if (this.randomAlphaValue == true) {
      alpha = this.getRandom(10, 100) / 100;
    }
    this.currentColor = hue + "," + sat + "," + val + "," + alpha;
    this.rgbColor = this.hsv2rgba(hue, sat, val, alpha);
    this.currentFill = this.rgbColor;
    if (this.usepalettebox == true) {
      this.rgbColor = this.nextColor(hue, sat, val, alpha);
    }
    return this.rgbColor;
  }

  private hsv2rgba(h, s, v, alpha) {
    var r;
    var g;
    var b;
    var i;
    var f;
    var p;
    var q;
    var t;
    var myflag;
    h = h / 360;
    s = s / 100;
    v = v / 100;
    //############
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);
    //##############
    myflag = i % 6;
    //console.log(myflag);
    if (myflag == 0) {
      r = v;
      g = t;
      b = p;
    } else if (myflag == 1) {
      r = q;
      g = v;
      b = p;
    } else if (myflag == 2) {
      r = p;
      g = v;
      b = t;
    } else if (myflag == 3) {
      r = p;
      g = q;
      b = v;
    } else if (myflag == 4) {
      r = t;
      g = p;
      b = v;
    } else if (myflag == 5) {
      r = v;
      g = p;
      b = q;
    }
    r = r * 255;
    g = g * 255;
    b = b * 255;
    r = Math.round(r);
    g = Math.round(g);
    b = Math.round(b);
    this.rgbColor = "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
    return this.rgbColor;
  }

  private getRandom(min, max) {
    var mynum = Math.random() * (max - min) + min;
    mynum = Math.floor(mynum);
    return mynum;
  }
  private downloadbasement() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.kitchen = document.getElementById("kitchen").innerHTML;
    this.kitchen = this.newbase + this.kitchen;
    document.getElementById("kitchen").innerHTML = this.kitchen
    this.setShape('#kitchen');
    this.kitchen1 = true;
    this.downloadArt("#kitchen");
  }
  private downloadArt(id) {
    var svg = document.getElementById(id),
      xml = new XMLSerializer().serializeToString(svg),
      data = "data:image/svg+xml;base64," + btoa(xml),
      img = new Image();
    img.setAttribute("src", data);
    img.setAttribute("download", "image.svg");
    img.setAttribute("id", "myimage");
    var artplace = document.getElementById("art");
    artplace.insertBefore(img, artplace.firstChild);
    this.mysvgfile = String(img);
    this.scrollartcontrol();
    console.log("mysvgfile \n" + this.mysvgfile);
  }

  private clearartarea() {
    var artplace = document.getElementById("art");
    var child = artplace.lastElementChild;
    while (child) {
      artplace.removeChild(child);
      child = artplace.lastElementChild;
    }
  }

  private bigart() {
    this.stageSize = 5000;
  }


  private normalart() {
    this.stageSize = 500;
  }


  private pastesvgobject() {
    this.thing = "";
    this.pasteSVGcodeString = prompt("Paste SVG code here");
    this.pasteSVGcodeString.replace(/\r\n/, "");
    this.pasteSVGcodeString.replace(/\/>/, 'vector-effect="non-scaling-stroke" />');
    //console.log("1" + this.pasteSVGcodeString);
    this.pasteSVGcodeString.replace(/>/, 'vector-effect="non-scaling-stroke" >');
    //console.log("2" + this.pasteSVGcodeString);
    if (this.pasteSVGcodeString == "") {
      this.pasteSVGcodeString =
        '<polygon fill="#F5DC37" stroke="#000000" stroke-miterlimit="10" points="206.323,570.564 421.252,259.573 255.097,398.838 288.379,403.242 146.364,573.303 273.729,452.972 "></polygon>' +
        '<polygon fill="#3EA1DA" stroke="#000000" stroke-miterlimit="10" points="258.204,603.367 361.429,202.403 253.675,410.341 284.185,401.271 206.188,630.473 285.033,457.382 "></polygon>' +
        '<polygon fill="#40AFCE" stroke="#000000" stroke-miterlimit="10" points="366.662,421.977 104.676,482.109 343.157,326.508 283.908,392.52 469.607,314.571 291.628,419.194 "></polygon>' +
        '<polygon fill="#F5DC37" stroke="#000000" stroke-miterlimit="10" points="339.196,438.413 100.11,420.35 363.922,351.862 285.857,391.91 471.498,374.968 279.88,416.396 "></polygon>' +
        '<polygon fill="#D81869" stroke="#000000" stroke-miterlimit="10" points="316.82,460.423 132.576,317.93 360.932,402.747 287.753,393.85 439.586,479.128 276.079,410.71 "></polygon>' +
        '<polygon fill="#3EA1DA" stroke="#000000" stroke-miterlimit="10" points="292.678,466.197 188.362,247.903 343.676,443.218 288.721,395.614 383.801,549.155 274.772,403.004 "></polygon>' +
        '<polygon fill="#7AC143" stroke="#000000" stroke-miterlimit="10" points="274.893,446.82 230.458,236.854 330.322,465.159 289.398,398.356 341.705,560.205 273.951,394.059 "></polygon>' +
        '<polygon fill="#EE1E42" stroke="#000000" stroke-miterlimit="10" points="264.39,423.334 277.161,243.377 308.658,477.564 289.138,400.297 295.189,552.502 276.6,385.751 "></polygon>'
    }
    this.processsvgobject(this.pasteSVGcodeString);
  }

  private pasteimageaddress() {
    this.thing = "";
    this.startaddress = '<image class="draggable" width="200" height="100" xlink: href="';
    this.endaddress = '"></image>';
    this.pasteImagecodeString = prompt("Paste image address here");
    this.pasteImagecodeString.replace(/\r\n/, "");
    this.pasteImagecodeString.replace(/\/>/, 'vector-effect="non-scaling-stroke" />');
    //console.log("1" + this.pasteImagecodeString);
    this.pasteImagecodeString.replace(/>/, 'vector-effect="non-scaling-stroke" >');
    //console.log("2" + this.pasteImagecodeString);
    if (this.pasteImagecodeString == "") {
      this.pasteImagecodeString = 'assets/images/mathartshaper.jpg';
    }
    this.pasteImagecodeString = this.startaddress + this.pasteImagecodeString + this.endaddress;
    //console.log(this.pasteImagecodeString);
    this.processsvgobject(this.pasteImagecodeString);
    this.artData = '5_86_30_86_0_1.911_0_0_0_0_242_60_100_1_0_0_147_#basement_false_false_false_false_false_false_false_false_false_false_false_false';
    this.processArtData(this.artData);
  }

  private typeintext() {
    this.thing = "";
    this.startaddress = '<text class="draggable" class="mytext" >';
    this.endaddress = '</text>';
    this.typetextString = prompt("Type in text here: ");
    this.typetextString.replace(/\r\n/, "");
    //console.log("2" + this.typetextString);
    if (this.typetextString == "") {
      this.typetextString = 'Mathart.us';
    }
    this.typetextString = this.startaddress + this.typetextString + this.endaddress;
    //console.log(this.typetextString);
    this.processsvgobject(this.typetextString);
    //this.strokeWidth = 0;
    this.artData = ' 1_50_1_40_14_0.171_0_0_0_0_10_100_100_1_0_0_0_#basement_false_false_false_false_false_false_false_false_false_false_false_false';
    this.processArtData(this.artData);
  }
  
  private processsvgobject(artData) {
    artData.replace(/\r\n/, "");
    this.artData = artData;
    this.artData = this.cleanThis(this.artData);
    this.re = /@/;
    if (this.artData.match(this.re)) {
      this.info = this.artData.split("@");
      this.newProject = this.info[0];
      this.thing = this.info[1];
      this.thing = this.cleanThis(this.thing);
    }
    else {
      this.thing = this.artData;
      this.thing = this.cleanThis(this.thing);
    }
    this.setShape("#basement");
    this.shapeName = '#basement';
    document.getElementById("basement").innerHTML = this.thing;
    this.shapeData = this.thing;
    this.showData = "@" + this.shapeData;
    //console.log("processsvg000 - thing - " + this.thing);
  }


  
  private polyit(event) {
    event.preventDefault();
    var myx = event.clientX;
    var myy = event.clientY;
    //myx = myx - 675;
    //myy = myy - 305;
    this.polyshape = document.getElementById("polyshape").innerHTML;
    this.polyshape = this.polyshape.replace(/"><\/polygon>/, myx + "," + myy + ' "></polygon>');
    //console.log(this.polyshape);
    document.getElementById("polyshape").innerHTML = this.polyshape;
    //console.log(this.polyshape);
};

  private mydownload(filename, text) {
    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(text)
    );
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }


  private readArtData(filenameout) {
    if (this.shapeName == "#basement") { }
    else {
      this.buildbasement();
    }
    var outputartdata;
    outputartdata = '\<!DOCTYPE html \>' +
      ' \<html lang="en" \>' +
      ' \<head\>' +
      ' \<meta charset="utf-8" /\>' +
      ' \<meta http - equiv="X-UA-Compatible" content = "IE=edge,chrome=1" /\>' +
      ' \<title\>' +
      this.shapeName +
      '\</title\>' +
      ' \< link href = "layout-styles.css" rel = "stylesheet" type = "text/css" media = "screen" /\>' +
      ' \<style\>' +
      '.centerit {align- items: center;text - align: center;}' +
      ' \</style\>' +
      ' \< /head\>' +
      ' \< body \>' +
      '\<h2\>' +
      this.shapeName +
      '\</h2\>' +
      '\< div \>\<em\>\<p\>arrayBar: ' + this.numberShapes + ' \</p \> \<br / \>' +
      ' \<p\>Spread: ' + this.spreadsize + ' \</p \> \<br / \>' +
      ' \<p\>Zoom: ' + this.zoomsize + ' \</p \> \<br / \>' +
      ' \<p\> Layers: ' + this.layers + '  \<br /\>\</p \> ' +
      ' \<p\> Rotate: ' + this.rotateValue + '  \<br /\>\</p \> ' +
      ' \<p\> Scale: ' + this.scale + '  \<br /\>\</p \> ' +
      ' \<p\> SkewX: ' + this.skewXValue + '  \<br /\>\</p \> ' +
      ' \<p\> SkewY: ' + this.skewYValue + '  \<br /\>\</p \> ' +
      ' \<p\> 9Horizontal: ' + this.translateHValue + '  \<br /\>\</p \> ' +
      ' \<p\> Vertical: ' + this.translateVValue + '  \<br /\>\</p \> ' +
      ' \<p\> Hue: ' + this.hue + '  \<br /\>\</p \> ' +
      ' \<p\> Sat: ' + this.sat + '  \<br /\>\</p \> ' +
      ' \<p\> Val: ' + this.val + '  \<br /\>\</p \> ' +
      ' \<p\> Alpha: ' + this.alpha + '  \<br /\>\</p \> ' +
      ' \<p\> StrokeColor: ' + this.stroke + '  \<br /\>\</p \> ' +
      ' \<p\> StrokeWidth: ' + this.strokeWidth + '  \<br /\>\</p \> ' +
      ' \<p\> BackgroundColor: ' + this.backg + '  \<br /\>\</p \> ' +
      ' \<p\> Container: ' + this.shapeName + '  \<br /\>\</p \> ' +
      ' \<p\> 9RotateRandom: ' + this.randomRotateValue + '  \<br /\>\</p \> ' +
      ' \<p\> ScaleRandom: ' + this.randomScaleValue + '  \<br /\>\</p \> ' +
      ' \<p\> SkewXRandom: ' + this.randomSkewXValue + '  \<br /\>\</p \> ' +
      ' \<p\> SkewYRandom: ' + this.randomSkewYValue + '  \<br /\>\</p \> ' +
      ' \<p\> HorizontalRandom: ' + this.randomHValue + '  \<br /\>\</p \> ' +
      ' \<p\> VerticalRandom: ' + this.randomVValue + '  \<br /\>\</p \> ' +
      ' \<p\> HueRandom: ' + this.randomHueValue + '  \<br /\>\</p \> ' +
      ' \<p\> SatRandom: ' + this.randomSatValue + '  \<br /\>\</p \> ' +
      ' \<p\> ValRandom: ' + this.randomValValue + '  \<br /\>\</p \> ' +
      ' \<p\> AlphaRandom: ' + this.randomAlphaValue + '  \<br /\>\</p \> ' +
      ' \<p\> 9StrokeColorRandom: ' + this.randomStrokeColorValue + '  \<br /\>\</p \> ' +
      ' \<p\> StrokeWidthRandom: ' + this.randomStrokeWidthValue + '  \<br /\>\</p \> ' +
      '\< /em\>' +
      ' \</div \>' +
      ' \</div\>' +
      '\< /body\>' +
      ' \< /html\>'
      ;
    this.filenameout = this.shapeName + "_ReadArtData.html";
    this.filenameout = this.filenameout.replace(/#/, "");
    this.mydownload([this.filenameout], outputartdata);
    console.log("this.artdata: " + outputartdata);
    window.open("http://localhost:4200/", this.filenameout);
  }

  private saveArtData() {
    this.artData =
      this.numberShapes +
      "_" +
      this.spreadsize +
      "_" +
      this.zoomsize +
      "_" +
      this.layers +
      "_" +
      this.rotateValue +
      "_" +
      this.scale +
      "_" +
      this.skewXValue +
      "_" +
      this.skewYValue +
      "_" +
      this.translateHValue +
      "_" +
      this.translateVValue +
      "_" +
      this.hue +
      "_" +
      this.sat +
      "_" +
      this.val +
      "_" +
      this.alpha +
      "_" +
      this.stroke +
      "_" +
      this.strokeWidth +
      "_" +
      this.backg +
      "_" +
      this.shapeName +
      "_" +
      this.randomRotateValue +
      "_" +
      this.randomScaleValue +
      "_" +
      this.randomSkewXValue +
      "_" +
      this.randomSkewYValue +
      "_" +
      this.randomHValue +
      "_" +
      this.randomVValue +
      "_" +
      this.randomHueValue +
      "_" +
      this.randomSatValue +
      "_" +
      this.randomValValue +
      "_" +
      this.randomAlphaValue +
      "_" +
      this.randomStrokeColorValue +
      "_" +
      this.randomStrokeWidthValue;
    this.filenameout = this.shapeName + "_artData.txt";
    this.filenameout = this.filenameout.replace(/#/, "");
    this.mydownload([this.filenameout], this.artData);
    console.log("this.artdata: " + this.outdata);
  }

    private exportArt(shapeName) {  
      this.saveArtData();
      this.savesvgobject(shapeName);

  }

  private savesvg(mydiv) {
    var space = document.getElementById(mydiv).innerHTML;
    var dataout = mydiv+"_shape.txt";
    this.mydownload([dataout], space);
  
  }

  private savesvgobject(shapeName) {
    if (this.shapeName === "#polyshape") {
      this.shapeData = document.getElementById("polyshape").innerHTML;
    } else if (this.shapeName === "#newshape") {
      this.shapeData = document.getElementById("newshape").innerHTML;
    } else if (this.shapeName === "#fileShape") {
      this.shapeData = document.getElementById("fileShape").innerHTML;
    } else if (this.shapeName === "#basement") {
      this.shapeData = document.getElementById("basement").innerHTML;
    } else if (this.shapeName === "#kitchen") {
      this.shapeData = document.getElementById("kitchen").innerHTML;
    } else {
      this.shapeID = this.setShape(this.shapeName);
      this.shapeData = document.getElementById(this.shapeID).innerHTML;
    }
    var dataout = this.shapeID;
    dataout = dataout + "_shape.txt";
    this.mydownload([dataout], this.shapeData);
  }

    private savemypng(id) {
    var n = (Math.floor(Math.random() * (9999 - 1000) + 1000));
    var svg = document.getElementById(id),
    xml = new XMLSerializer().serializeToString(svg),
    data = "data:image/svg+xml;base64," + btoa(xml),
    img = new Image();
    img.setAttribute("src", data);
    img.setAttribute("download", "image.png");
    img.setAttribute("id", "myimage");
    var artplace = document.getElementById("art");
    artplace.appendChild(img);
      console.log("mysvgfile" + svg);
      console.log("mydata" + data);
      console.log("myimg" + img);
    var pngoutname = "PNG-" + n + ".png";
   this.mydownload([pngoutname], img);
    

  }
  
  private pasteArtData() {
    //prompt for artData
    this.pasteArtDataString = prompt("Paste artData Here:\n");
    this.pasteArtDataString.replace(/\r\n/, "");
    if (this.pasteArtDataString == "") {
      this.pasteArtDataString = "3_200_20_168_5_0.23_0_0_0_0_10_100_100_1_0_5_0_#stick_false_false_false_false_false_false_false_false_false_false_false_false";
    }
    this.re = /@/;
    if (this.pasteArtDataString.match(this.re)) {
      this.info = this.pasteArtDataString.split("@");
      this.newProject = this.info[0];
      this.thing = this.info[1];
      this.processArtData(this.newProject);
      if (this.thing !== "") {
        this.processsvgobject(this.thing)
      }
    }
    else {
      this.processArtData(this.pasteArtDataString);
    }
  }

  private processArtData(artData) {
    this.artData = artData;
    var newArt = this.artData.split("_");
    var newName = "";
    // console.log("newArt" + newArt);
    this.numberShapes = Number(newArt[0]);
    this.spreadsize = Number(newArt[1]);
    this.zoomsize = Number(newArt[2]);
    this.layers = Number(newArt[3]);
    this.rotateValue = Number(newArt[4]);
    this.scale = Number(newArt[5]);
    this.skewXValue = Number(newArt[6]);
    this.skewYValue = Number(newArt[7]);
    this.translateHValue = Number(newArt[8]);
    this.translateVValue = Number(newArt[9]);
    this.hue = Number(newArt[10]);
    this.sat = Number(newArt[11]);
    this.val = Number(newArt[12]);
    this.alpha = Number(newArt[13]);
    this.stroke = Number(newArt[14]);
    this.strokeWidth = Number(newArt[15]);
    this.backg = Number(newArt[16]);
    this.newName = String(newArt[17]);
    this.randomRotateValue = (newArt[18] + "").toLowerCase() === "true";
    this.randomScaleValue = (newArt[19] + "").toLowerCase() === "true";
    this.randomSkewXValue = (newArt[20] + "").toLowerCase() === "true";
    this.randomSkewYValue = (newArt[21] + "").toLowerCase() === "true";
    this.randomHValue = (newArt[22] + "").toLowerCase() === "true";
    this.randomVValue = (newArt[23] + "").toLowerCase() === "true";
    this.randomHueValue = (newArt[24] + "").toLowerCase() === "true";
    this.randomSatValue = (newArt[25] + "").toLowerCase() === "true";
    this.randomValValue = (newArt[26] + "").toLowerCase() === "true";
    this.randomAlphaValue = (newArt[27] + "").toLowerCase() === "true";
    this.randomStrokeColorValue = (newArt[28] + "").toLowerCase() === "true";
    this.randomStrokeWidthValue = (newArt[29] + "").toLowerCase() === "true";
    this.outputTransform(
      "rotate",
      this.rotateValue,
      this.randomRotateValue,
      "scale",
      this.scale,
      this.randomScaleValue,
      "skewX",
      this.skewXValue,
      this.randomSkewXValue,
      "skewY",
      this.skewYValue,
      this.randomSkewYValue,
      "translate",
      this.translateHValue,
      this.randomHValue,
      this.translateVValue,
      this.randomVValue,
      this.numberShapes
    );
    this.strokeWithWhite2rgba(this.stroke);
    this.backgWithWhite2rgba(this.backg);
    this.hsv2rgba(this.hue, this.sat, this.val, this.alpha);
    ////////////////////////////////////////////////////////////////////////

    if (this.lockShape === false) {
      this.shapeName = this.newName;
    }
    if (this.lockShape === true) {
    }
    this.shapeID = this.setShape(this.shapeName);
    this.thing = document.getElementById(this.shapeID).innerHTML;

    document.getElementById(this.shapeID).innerHTML = this.thing;

  }

  private convertStageSize(stageSize) {
    stageSize = Number(stageSize);
    this.stageHalf = Number(stageSize / 2);
    this.svgx = ' x="' + this.stageHalf + ' px "';
    this.svgy = ' y="' + this.stageHalf + ' px "';
    this.svgwidtth = ' width="' + this.stageSize + ' px "';
    this.svgheight = ' height="' + this.stageSize + ' px "';
    this.svgviewbox = ' viewBox="' + this.stageHalf + ' ' + this.stageHalf + ' ' + stageSize + ' ' + stageSize + '"';
    this.svgstage = '<svg id="playspace" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"' +
      this.svgx +
      this.svgy +
      this.svgwidtth +
      this.svgheight +
      this.svgviewbox +
      ">";
    var line = document.getElementById("playspace");
    this.svgx = ' x="' + this.stageHalf + ' px "';
    this.svgy = ' y="' + this.stageHalf + ' px "';
    line.setAttribute("width", String(this.stageSize));
    line.setAttribute("height", String(this.stageSize));
    line.setAttribute(
      "viewbox",
      "" +
      this.stageHalf +
      " " +
      this.stageHalf +
      " " +
      stageSize +
      " " +
      stageSize +
      ""
    );
    return this.svgstage;
  }

  private randomFlow() {
    var count;
    for (count = 0; count < 100; count++) {
      this.mynum = Math.random();
      this.mynum = Math.floor(this.mynum);
    }
  }

  private fileChanged(e) {
    this.file = e.target.files[0];
  }

  private killColor() {
    var myobject;
    var plen;
    var i;
    var code;
    //var re = /<path\s+\w+\W+d=/gi;
    myobject = document.getElementById("basement").innerHTML;
    var parts = myobject.split(" ")
    plen = parts.length;
    for (i = 0; i < plen; i++) {
      if (parts[i].match("stroke")) { parts[i] = ""; }
      else if (parts[i].match("fill")) { parts[i] = ""; }
      code = parts.join(' ');
    }
    myobject = myobject + " " + code;
    document.getElementById("basement").innerHTML = myobject;

  }
  private useColor(paletteString) {
    var i = 0;
    this.colorString = paletteString.split(" ");
    this.plength = this.colorString.length;
    console.log(this.plength + "  this.colorString  " + this.colorString);
    for (i = 0; i < this.plength; i++) {
      var part = this.colorString[i].split(",");
      console.log("part   " + part);
      console.log("paletteString   " + paletteString);
      console.log(" this.colorString   " + this.colorString);
      var hue = Number(part[0]);
      var sat = Number(part[1]);
      var val = Number(part[2]);
      // var alpha = Number(part[3]);
      this.colors[i] = hue + "," + sat + "," + val + "," + this.alpha;
    }
  }

  private nextColor(hue, sat, val, alpha) {
    /*
        this.colorString = this.paletteString.split(" ");
        this.plength = this.colorString.length;
        */
    if (this.randomColor == true) {
      var rancount = this.getRandom(0, 360);
      this.colorNumber = rancount % this.plength;
    } else {
      this.colorNumber = this.counter % this.plength;
    }
    var part = this.colors[this.colorNumber].split(",");
    hue = Number(part[0]);
    sat = Number(part[1]);
    val = Number(part[2]);
    alpha = Number(part[3]);
    this.rgbColor = this.hsv2rgba(hue, sat, val, alpha);
    return this.rgbColor;
  }

  private addColor(selectedColor) {
    //console.log("selectedColor", selectedColor);
    selectedColor.a = this.alpha;
    if (this.pastePaletteString) {
      this.paletteString = this.pastePaletteString;
      // console.log("paletteString", this.paletteString);
    }
    else {
      if (this.paletteString === "") {
        this.paletteString +=
          selectedColor.h +
          "," +
          selectedColor.s +
          "," +
          selectedColor.b +
          "," +
          selectedColor.a;
      }
      else {
        this.paletteString =
          this.paletteString +
          " " +
          selectedColor.h +
          "," +
          selectedColor.s +
          "," +
          selectedColor.b +
          "," +
          selectedColor.a;
      }
    }
    //return this.paletteString;
    this.useColor(this.paletteString);
    if (this.usepalettebox == true) {
      selectedColor.a = this.alpha;
      this.rgbColor = this.nextColor(selectedColor.h, selectedColor.s, selectedColor.b, selectedColor.a);
      this.pastePaletteString = "";
      return this.rgbColor;
    }
  }

  private newPalette() {
    this.paletteString = "";
    this.useColor(this.paletteString);
  }

  private pastePalette() {
    this.pastePaletteString = prompt("Add a Palette");
    if (this.pastePaletteString == "") {
      this.pastePaletteString = '356,94,97,1 356,4,99,1 241,92,97,1';
    }
    this.useColor(this.pastePaletteString);
    return this.pastePaletteString;
  }

  private savePalette(filenameout) {
    var dataout = this.yourname + "_palette.txt";
    this.mydownload([dataout], this.paletteString);
    this.useColor(this.paletteString);
  }

  private rotateit(irotate) {
    this.duplicateShape = true;
    this.rememberDefaults();
    this.irotate = irotate;
    this.atype = "rotate";
    this.avalues = 0 + ';' + irotate + ';' + 0;
    var myset = irotate;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive();
    this.recallDefaults();
    irotate = myset;
  }

  private rockit(irock) {
    this.rememberDefaults();
    this.irotate = irock;
    this.atype = "rotate";
    this.avalues = 0 + ';' + irock + ';' + 0;
    var myset = irock;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive();
    this.recallDefaults();
    irock = myset;
  }

  private scaleitX(iscaleX) {
    this.duplicateShape = true;
    this.rememberDefaults();
    this.iscaleX = iscaleX;
    this.atype = "scale";
    this.avalues = 1 + ' ' + 1 + ';' +
      iscaleX + ' ' + 1 + ';' +
      1 + ' ' + 1 + ';' +
      -iscaleX + ' ' + 1 + ';' +
      1 + ' ' + 1;
    var myset = iscaleX;
    this.irotate = 0;
    //this.iscaleX = .95;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive();
    this.recallDefaults();
    iscaleX = myset;
  }

  private scaleitY(iscaleY) {
    this.duplicateShape = true;
    this.rememberDefaults();
    this.iscaleY = iscaleY;
    this.atype = "scale";
    this.avalues = 1 + ' ' + 1 + ';' +
      1 + ' ' + iscaleY + ';' +
      1 + ' ' + 1;
    var myset = iscaleY;
    this.irotate = 0;
    this.iscaleX = 1;
    //this.iscaleY = .9;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive();
    this.recallDefaults();
    iscaleY = myset;
  }

  private scaleit(iscale) {
    this.duplicateShape = true;
    this.rememberDefaults();
    this.iscale = iscale;
    this.atype = "scale";
    this.avalues = .1 + ';' + iscale + ';' + .1;
    var myset = iscale;
    this.irotate = 0;
    this.iscaleX = iscale;
    this.iscaleY = iscale;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive();
    this.recallDefaults();
    iscale = myset;
  }

  private skewitX(iskewX) {
    this.duplicateShape = true;
    this.rememberDefaults();
    this.iskewX = iskewX;
    this.atype = "skewX";
    this.avalues = 0 + ';' +
      iskewX + ';' +
      0 + ';' +
      -iskewX + ';' +
      0;
    var myset = iskewX;
    this.irotate = 0;
    this.iscaleX = 1;
    this.iscaleY = 1;
    //this.iskewX = 20;
    this.iskewY = 0;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive();
    this.recallDefaults();
    iskewX = myset;
  }

  private skewitY(iskewY) {
    this.duplicateShape = true;
    this.rememberDefaults();
    this.iskewY = iskewY;
    this.atype = "skewY";
    this.avalues = 0 + ';' +
      iskewY + ';' +
      0 + ';' +
      -iskewY + ';' +
      0;
    var myset = iskewY;
    this.irotate = 0;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iskewX = 0;
    //this.iskewY = -30;
    this.imoveh = 0;
    this.imovev = 0;
    this.processprimitive();
    this.recallDefaults();
    iskewY = myset;
  }

  private moveith(imoveh) {
    this.duplicateShape = true;
    this.rememberDefaults();
    this.imoveh = this.scale * imoveh;
    this.atype = "translate";
    this.avalues = 0 + ' ' + 0 + ';' +
      imoveh + ' ' + 0 + ';' +
      0 + ' ' + 0 + ';' +
      -imoveh + ' ' + 0 + ';' +
      0 + ' ' + 0;
    var myset = imoveh;
    this.irotate = 0;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    //this.imoveh = 80;
    this.imovev = 0;
    this.processprimitive();
    this.recallDefaults(); this.recallDefaults();
    imoveh = myset;
  }

  private moveitv(imovev) {
    this.duplicateShape = true;
    this.rememberDefaults();
    this.imovev = this.scale * imovev;
    this.atype = "translate";
    this.avalues =
      0 + ' ' + 0 + ';' +
      0 + ' ' + imovev + ';' +
      0 + ' ' + 0 + ';' +
      0 + ' ' + -imovev + ';' +
      0 + ' ' + 0;
    var myset = imovev;
    this.irotate = 0;
    this.iscaleX = 1;
    this.iscaleY = 1;
    this.iskewX = 0;
    this.iskewY = 0;
    this.imoveh = 0;
    //this.imovev = 80
    this.processprimitive();
    this.recallDefaults();
    imovev = myset;
  }

  private flipleft(imoveh) {
    
    this.iscaleX = -1;
    this.imoveh = imoveh;
    this.shapeID = this.setShape("#basement");
    var myshape = document.getElementById(this.shapeID);
    var mymirror = myshape.innerHTML;
    var action = '<g transform ="' +
      "rotate(" + 0 + "," + 0 + "," + 0 + ") " +
      "scale(" + -1 + "," + 1 + ") " +
      "skewX(" + 0 + ") " +
      "skewY(" + 0 + ") " +
      "translate(" +
      this.imoveh +
      "," +
      0 +
      ')">';
    action = action + mymirror + '</g>';
    mymirror = mymirror + action;
    if (this.duplicateShape == true) {
      document.getElementById(this.shapeID).innerHTML = mymirror;
    }
    else if (this.moveShape == true) {
      document.getElementById(this.shapeID).innerHTML = action;
    }
  }

  


  private flipup(imovev) {
    this.iscaleY = this.iscaleY * -1;
    this.imovev = imovev
    this.shapeID = this.setShape("#basement");
    var myshape = document.getElementById(this.shapeID);
    var mymirror = myshape.innerHTML;
    var action = '<g transform ="' +
      "rotate(" + 0 + "," + 0 + "," + 0 + ") " +
      "scale(" + 1 + "," + -1 + ") " +
      "skewX(" + 0 + ") " +
      "skewY(" + 0 + ") " +
      "translate(" +
      0 +
      "," +
      this.imovev +
      ')">';
    action = action + mymirror + '</g>';
    mymirror = mymirror + action;
    if (this.duplicateShape == true) {
      document.getElementById(this.shapeID).innerHTML = mymirror;
    }
    else if (this.moveShape == true) {
      document.getElementById(this.shapeID).innerHTML = action;
    }
  }

  private killit(event) {
    var selectedElement = event.target;
    if (selectedElement) {
      event.preventDefault();
      alert(event.target);
      event.target.remove();
      alert(event.target);
    }
  }

  private xflipleft(iscaleX) {
    this.iscaleX = iscaleX;
    this.lockscale = false;
    this.iscaleX = this.iscaleX * -1;
    this.outputBasement();
  }

  private xflipup(imovev) {
    this.lockscale = false;
    this.iscaleY = this.iscaleY * -1;
    this.outputBasement();
  }

  private rememberDefaults() {
    this.modifyit = [
      this.irotate,
      this.iscaleX,
      this.iscaleY,
      this.iscale,
      this.iskewX,
      this.iskewY,
      this.imoveh,
      this.imovev,
      this.default];
    return this.modifyit;
  }

  private recallDefaults() {
    this.irotate = this.modifyit[0];
    this.iscaleX = this.modifyit[1];
    this.iscaleY = this.modifyit[2];
    this.iscale = this.modifyit[3];
    this.iskewX = this.modifyit[4];
    this.iskewY = this.modifyit[5];
    this.imoveh = this.modifyit[6];
    this.imovev = this.modifyit[7];
    this.default = this.modifyit[8];
  }

  private clearall() {
    this.default = 6;
  }

  private defaults() {
    if (this.default == 1) {
      this.irotate = 45;
       this.iscale = 3;
      this.iscaleX = .8;
      this.iscaleY = .8;     
      this.iskewX = 30;
      this.iskewY = 30;
      this.imoveh = 0;
      this.imovev = 100;
      this.default = 2;
      this.lockscale = true
    }
    else if (this.default == 2) {
      this.irotate = 90;
      this.iscaleX = -1;
      this.iscaleY = -1;
      this.iscale = -.8;
      this.iskewX = -20;
      this.iskewY = -20;
      this.imoveh = -20;
      this.imovev = -20;
      this.default = 3;
      this.lockscale = false
    }
    else if (this.default == 3) {
      this.irotate = 360;
      this.iscaleX = 4;
      this.iscaleY = 4;
      this.iscale = 5;
      this.iskewX = 60;
      this.iskewY = 60;
      this.imoveh = 20;
      this.imovev = 20;
      this.default = 4;
      this.lockscale = true
    }
    else if (this.default == 4) {
      this.irotate = 180;
      this.iscaleX = 2;
      this.iscaleY = -5;
      this.iscale = 1;
      this.iskewX = 20;
      this.iskewY = 20;
      this.imoveh = 20;
      this.imovev = 20;
      this.default = 5;
      this.lockscale = true
    }
    else if (this.default == 5) {
      this.irotate = 60;
      this.iscaleX = 1.5;
      this.iscaleY = 1.5;
      this.iscale = .7;
      this.iskewX = 30;
      this.iskewY = 30;
      this.imoveh = 20;
      this.imovev = 20;
      this.default = 6;
      this.lockscale = false
    }
    else if (this.default == 6) {
      this.irotate = 0;
      this.iscaleX = 1;
      this.iscaleY = 1;
      this.iscale = 1;
      this.iskewX = 0;
      this.iskewY = 0;
      this.imoveh = 0;
      this.imovev = 0;
      this.default = 7;
      this.lockscale = true
    }
    else if (this.default == 7) {
      this.irotate = -60;
      this.iscaleX = -1.5;
      this.iscaleY = -1.5;
      this.iscale = -3;
      this.iskewX = -10;
      this.iskewY = -10;
      this.imoveh = -200;
      this.imovev = -200;
      this.default = 1;
      this.lockscale = false

    }
  }

  private processprimitive() {
    this.shapeID = this.setShape(this.shapeName);
    var myshape = document.getElementById(this.shapeID);
    var mymirror = myshape.innerHTML;
    var action = '<g transform ="' +
      "rotate(" + this.irotate + "," + 0 + "," + 0 + ") " +
      "scale(" + this.iscaleX + "," + this.iscaleY + ") " +
      "skewX(" + this.iskewX + ") " +
      "skewY(" + this.iskewY + ") " +
      "translate(" +
      this.imoveh +
      "," +
      this.imovev +
      ')">';
    action = action + mymirror + '</g>';
    mymirror = mymirror + action;
    if (this.duplicateShape == true) {
      document.getElementById(this.shapeID).innerHTML = mymirror;
    }
    else if (this.moveShape == true) {
      document.getElementById(this.shapeID).innerHTML = action;
    }
    this.default = 1;
    this.defaults();
  }



  private showbasement() {
    var block1 = document.getElementById("backlot");
    if (block1.style.visibility == "visible") {
      block1.style.visibility = "hidden";
      //console.log("if "+block1.style.visibility);

    }
    else if (block1.style.visibility == "hidden") {
      block1.style.visibility = "visible";
      //console.log("else if "+block1.style.visibility);
    }
    else {
      block1.style.visibility = "visible";
      //console.log("else "+block1.style.visibility);

    }

  }

  private movebasement() {
    var block1 = document.getElementById("backlot");
    block1.style.visibility = "visible";
    if ((block1.style.left == "460px") && (block1.style.top == "700px")) {
      //move to cover display
      block1.style.left = "460px";
      block1.style.top = "200px";
      //console.log(block1.style.top + " " + block1.style.left);
    }
    else if ((block1.style.left == "1000px") && (block1.style.top == "200px")) {
      //move to bottom
      block1.style.left = "460px";
      block1.style.top = "700px";
      //console.log(block1.style.top + " " + block1.style.left);
    }
    else if ((block1.style.left == "460px") && (block1.style.top == "200px")) {
      //move to right
      block1.style.left = "1000px";
      block1.style.top = "200px";
      //console.log(block1.style.top + " " + block1.style.left);
    }
    else {
      block1.style.left = "460px";
      block1.style.top = "200px";
    }
  }
  private buildbasement() {

    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.basement = document.getElementById("basement").innerHTML;
    this.newbase = '<g class="draggable" > ' + this.newbase + " </g> \n";
    this.basement = '<g class="draggable" > ' + this.basement + " </g> \n";
    this.basement = this.newbase + this.basement;
    document.getElementById("basement").innerHTML = this.basement;
    //console.log("else" + this.basement);
    this.setShape('#basement');
    this.showData = this.basement;
    this.basement1 = true;
  }

  private buildkitchen() {
    this.shapeID = this.setShape(this.shapeName);
    this.newbase = document.getElementById(this.shapeID).innerHTML;
    this.kitchen = document.getElementById("kitchen").innerHTML;
    this.kitchen = this.newbase + this.kitchen;
    document.getElementById("kitchen").innerHTML = this.kitchen
    this.setShape('#kitchen');
    this.kitchen1 = true;
  }

  private clearbasement() {
    document.getElementById("basement").innerHTML = "";
  }

  private clearkitchen() {
    this.shapeName = "kitchen";
    this.shapeID = this.setShape(this.shapeName);
    document.getElementById(this.shapeName).innerHTML = "";
    this.shapeID = this.setShape(this.shapeName);
  }

  private BW() {
    if (this.backg == 0) { this.backg = 360; }
    if (this.backg == 360) { this.backg = 0; }
    return this.backg;
  }

  private oneShape() {
    if (this.shapeName == "#kitchen" || this.shapeName == "#polyshape") {
      this.buildbasement();
    }
    this.rememberArtData =
      this.numberShapes +
      "_" +
      this.spreadsize +
      "_" +
      this.zoomsize +
      "_" +
      this.layers +
      "_" +
      this.rotateValue +
      "_" +
      this.scale +
      "_" +
      this.skewXValue +
      "_" +
      this.skewYValue +
      "_" +
      this.translateHValue +
      "_" +
      this.translateVValue +
      "_" +
      this.hue +
      "_" +
      this.sat +
      "_" +
      this.val +
      "_" +
      this.alpha +
      "_" +
      this.stroke +
      "_" +
      this.strokeWidth +
      "_" +
      this.backg +
      "_" +
      this.shapeName +
      "_" +
      this.randomRotateValue +
      "_" +
      this.randomScaleValue +
      "_" +
      this.randomSkewXValue +
      "_" +
      this.randomSkewYValue +
      "_" +
      this.randomHValue +
      "_" +
      this.randomVValue +
      "_" +
      this.randomHueValue +
      "_" +
      this.randomSatValue +
      "_" +
      this.randomValValue +
      "_" +
      this.randomAlphaValue +
      "_" +
      this.randomStrokeColorValue +
      "_" +
      this.randomStrokeWidthValue;
    if (this.shapeName == "#basement ") {
      this.shapeID = this.setShape(this.shapeName);
      this.shapeData = document.getElementById(this.shapeID).innerHTML;
      this.showData = this.shapeData;
      this.rememberArtData = this.rememberArtData + "@" + this.shapeData;
      document.getElementById("rememberartdata").innerHTML = this.rememberArtData;
    }
    document.getElementById("rememberartdata").innerHTML = this.rememberArtData;
    //Set art data to one
    this.newProject = '1_0_60_1_5_2_0_0_0_0_10_100_100_1_0_5_360_' + this.shapeName + '_false_false_false_false_false_false_false_false_false_false_false_false';
    //console.log(" 3a- rememberArtData: " + this.rememberArtData);
    //console.log("3b- newProject: " + this.newProject);
    this.processArtData(this.newProject);
  }

  private recover() {
    this.artData = document.getElementById("rememberartdata").innerHTML;
    document.getElementById("rememberartdata").innerHTML = " ";
    this.processArtData(this.artData);
  }

  private scrolltop() {
    document.getElementById("top").scrollIntoView({ behavior: 'auto' });
  }

  private scrollbox() {
    document.getElementById("box").scrollIntoView({ behavior: 'auto' });
  }

  private scrollpaletteplacement() {
    document.getElementById("paletteplacement").scrollIntoView({ behavior: 'auto' });
  }

  private scrollplacement() {
    document.getElementById("placement").scrollIntoView({ behavior: 'auto' });
  }

  private scrollrememberartdata() {
    document.getElementById("rememberartdata").scrollIntoView({ behavior: 'auto' });
  }
  private scrolltransformation() {
    document.getElementById("transformation").scrollIntoView({ behavior: 'auto' });
  }

  private scrollprimitives() {
    document.getElementById("primitives").scrollIntoView({ behavior: 'auto' }); this.usecontainersbox = true;
  }

  private scrolldatacontrol() {
    document.getElementById("datacontrol").scrollIntoView({ behavior: 'auto' });
  }

  private scrollobjectcontrol() {
    document.getElementById("objectcontrol").scrollIntoView({ behavior: 'auto' });
  }

  private scrollartcontrol() {
    document.getElementById("artcontrol").scrollIntoView({ behavior: 'auto' });
  }

  private scrolltoolbox() {
    document.getElementById("toolbox").scrollIntoView({ behavior: 'auto' });
  }

  private scrollspecialsliders() {
    document.getElementById("specialsliders").scrollIntoView({ behavior: 'auto' });
  }

  private scrollshapesliders() {
    document.getElementById("shapesliders").scrollIntoView({ behavior: 'auto' });
  }

  private scrollcolorsliders() {
    document.getElementById("colorsliders").scrollIntoView({ behavior: 'auto' });
  }

  private scrollmoresliders() {
    document.getElementById("moresliders").scrollIntoView({ behavior: 'auto' });
  }

  private scrollPalette() {
    document.getElementById("palette").scrollIntoView({ behavior: 'auto' });
    if (this.usepalettebox == true) {
      this.usepalettebox = false;
    }
    else if (this.usepalettebox == false) {
      this.usepalettebox = true;
    }
  }

  private scrollcontainers() {
    document.getElementById("containers").scrollIntoView({ behavior: 'auto' });
    this.usecontainersbox = true;
  }

  private scrollpresets() {
    document.getElementById("presets").scrollIntoView({ behavior: 'auto' });
    this.usepresetsbox = true;
  }

  private scrollArtObjects() {
    document.getElementById("ArtObjects").scrollIntoView({ behavior: 'auto' });
    this.useArtObjectsbox = true;
  }
  private scrollBasementObjects() {
    document.getElementById("ModificationTools").scrollIntoView({ behavior: 'auto' });
  }
  
  private scrollShapeGenerator() {
    document.getElementById("shapegenerator").scrollIntoView({ behavior: 'auto' });
  }

  private getfactors() {
    this.factors = [
      "arrayBar",
      "Spread",
      "Zoom",
      "Layers",
      "Rotate",
      "Scale",
      "SkewX",
      "SkewY",
      "Horizontal",
      "Vertical",
      "Hue",
      "Sat",
      "Val",
      "Alpha",
      "StrokeColor",
      "StrokeWidth",
      "BackgroundColor",
      "Container"];
    return this.factors;
  }

  private getmyshape() {
    this.myshape = [
      "#circle",
      "#moon",
      "#ellipse",
      "#hexagon",
      "#leaves",
      "#octagon",
      "#pentagon",
      "#square",
      "#stick",
      "#triangle",
      "#heart",
      "#film",
      "#newshape",
      "#petal",
      "#compass",
      "#arrow",
      "#shapeart",
      "#circlec",
      "#diamondh",
      "#diamondv",
      "#angle",
      "#pyramid",
      "#sun",
      "#bug",
      "#greek",
      "#roman",
      "#arrowbox",
      "#blob",
      "#pointer",
      "#arrowtri",
      "#castle1",
      "#lightning1",
      "#cross",
      "#star",
      "#scribble"];


    return this.myshape;
  }

  private makeArtData() {
    this.myshape = this.getmyshape();
    this.factors = this.getfactors();
    var boo = this.getRandom(6, 1).toString();
    this.randomartdata = this.getRandom(1, 6).toString() + "_";//      "arrayBar",
    this.randomartdata = this.randomartdata + this.getRandom(1, 300).toString() + "_";//      "Spread",
    this.randomartdata = this.randomartdata + this.getRandom(10, 100).toString() + "_";//      "Zoom",
    this.randomartdata = this.randomartdata + this.getRandom(10, 180).toString() + "_";//      "Layers",
    this.randomartdata = this.randomartdata + this.getRandom(0, 360).toString() + "_";//      "Rotate",
    this.randomartdata = this.randomartdata + (this.getRandom(50, 400) / 100).toString() + "_";//      "Scale",
    this.randomartdata = this.randomartdata + this.getRandom(0, 50).toString() + "_";//      "SkewX",
    this.randomartdata = this.randomartdata + this.getRandom(0, 50).toString() + "_";//      "SkewY",
    this.randomartdata = this.randomartdata + this.getRandom(0, 300).toString() + "_";//      "Horizontal",
    this.randomartdata = this.randomartdata + this.getRandom(0, 200).toString() + "_";//      "Vertical",
    this.randomartdata = this.randomartdata + this.getRandom(0, 360).toString() + "_";//      "Hue",
    this.randomartdata = this.randomartdata + this.getRandom(60, 100).toString() + "_";//      "Sat",
    this.randomartdata = this.randomartdata + this.getRandom(100, 100).toString() + "_";//      "Val",
    this.randomartdata = this.randomartdata + this.getRandom(1, 1).toString() + "_";//      "Alpha",
    this.randomartdata = this.randomartdata + this.getRandom(0, 0).toString() + "_";//      "StrokeColor",
    this.randomartdata = this.randomartdata + this.getRandom(2, 2).toString() + "_";//      "StrokeWidth",
    if (this.lockbackg == false) {
      this.randomartdata = this.randomartdata + this.getRandom(0, 360).toString() + "_";
    }//      "BackgroundColor",
    else if (this.lockbackg == true) { this.randomartdata = this.randomartdata + this.backg.toString() + "_"; }//      "BackgroundColor",
    this.randomartdata = this.randomartdata + this.myshape[this.getRandom(0, 35)]; //      "Container"];
    console.log("randomartdata  " + this.randomartdata);
    this.processArtData(this.randomartdata);
  }

  private cleanThis(thisstring) {
    thisstring.replace(/\r\n/, "");
    return thisstring;
  }

  private makecoloringbook() {
    this.sat = 0;
    this.stroke = 0;
    this.strokeWidth = 2;
  }

  private readartdatafile() {
    var newProject;
    var mynamefile;
    var fileReader
    fileReader = new FileReader();
    mynamefile = prompt("enter filename to read");
    newProject = fileReader.readAsText(mynamefile);
    newProject = fileReader.result;
    this.processArtData(newProject);
  }


  private Moveto() {
    this.re = '"/>';
    this.codeline = document.getElementById("curvegroup");
    this.curvecode = this.codeline.innerHTML;
    console.log(this.curvecode);
    this.outputxx1 = document.getElementById("xx1value").innerHTML;
    this.outputyy1 = document.getElementById("yy1value").innerHTML;
    this.codestring = "M" + this.outputxx1 + "," + this.outputyy1 + this.re;
    this.curvecode = this.curvecode.replace(this.re, this.codestring);
    document.getElementById("curvegroup").innerHTML = this.curvecode;
    this.codeline = document.getElementById("curvegenerator").innerHTML;
    this.curvecode = this.codeline.innerHTML;
    this.curvecode = this.curvecode.replace(this.re, this.curvestring);
    document.getElementById("curvegenerator").innerHTML = this.curvecode;
    console.log(this.curvecode);

  }
  private Ccurve() {
    this.codeline = document.getElementById("curvegroup");
    this.curvecode = this.codeline.innerHTML;
    console.log(this.curvecode);

    this.outputxx1 = document.getElementById("xx1value").innerHTML;
    this.outputyy1 = document.getElementById("yy1value").innerHTML;
    this.outputxx2 = document.getElementById("xx2value").innerHTML;
    this.outputyy2 = document.getElementById("yy2value").innerHTML;
    this.outputxx3 = document.getElementById("xx3value").innerHTML;
    this.outputyy3 = document.getElementById("yy3value").innerHTML;
    this.curvestring = "C" + this.outputxx1 + "," + this.outputyy1 + " " +
      this.outputxx2 + "," + this.outputyy2 + " " +
      this.outputxx3 + "," + this.outputyy3 + this.re;
    this.curvecode = this.curvecode.replace('"/>', this.curvestring);
    document.getElementById("curvegroup").innerHTML = this.curvecode;
    this.codeline = document.getElementById("curvegenerator").innerHTML;
    this.curvecode = this.codeline.innerHTML;
    this.curvecode = this.curvecode.replace(this.re, this.curvestring);
    document.getElementById("curvegenerator").innerHTML = this.curvecode;
    console.log(this.curvecode);

  }
  private Qcurve() {
    this.codeline = document.getElementById("curvegroup");
    this.curvecode = this.codeline.innerHTML;
    console.log(this.curvecode);

    this.outputxx1 = document.getElementById("xx1value").innerHTML;
    this.outputyy1 = document.getElementById("yy1value").innerHTML;
    this.outputxx2 = document.getElementById("xx2value").innerHTML;
    this.outputyy2 = document.getElementById("yy2value").innerHTML;
    this.outputxx3 = document.getElementById("xx3value").innerHTML;
    this.outputyy3 = document.getElementById("yy3value").innerHTML;
    this.curvestring = "Q" + this.outputxx1 + "," + this.outputyy1 + " " +
      this.outputxx2 + "," + this.outputyy2 + " " +
      this.re;
    this.curvecode = this.curvecode.replace('"/>', this.curvestring);
    document.getElementById("curvegroup").innerHTML = this.curvecode;
    this.codeline = document.getElementById("curvegenerator").innerHTML;
    this.curvecode = this.codeline.innerHTML;
    this.curvecode = this.curvecode.replace(this.re, this.curvestring);
    document.getElementById("curvegenerator").innerHTML = this.curvecode;
    console.log(this.curvecode);

  }
  private Scurve() {
    this.codeline = document.getElementById("curvegroup");
    this.re = '"/>';
    this.curvecode = this.codeline.innerHTML;
    console.log(this.curvecode);

    this.outputxx1 = document.getElementById("xx1value").innerHTML;
    this.outputyy1 = document.getElementById("yy1value").innerHTML;
    this.outputxx2 = document.getElementById("xx2value").innerHTML;
    this.outputyy2 = document.getElementById("yy2value").innerHTML;
    this.curvestring = "S" + this.outputxx1 + "," + this.outputyy1 + " " +
      this.outputxx2 + "," + this.outputyy2 + " " +
      this.re;
    this.curvecode = this.curvecode.replace(this.re, this.curvestring);
    document.getElementById("curvegroup").innerHTML = this.curvecode;
    this.codeline = document.getElementById("curvegenerator").innerHTML;
    this.curvecode = this.codeline.innerHTML;
    this.curvecode = this.curvecode.replace(this.re, this.curvestring);
    document.getElementById("curvegenerator").innerHTML = this.curvecode;
    console.log(this.curvecode);

  }
  private Tcurve() {
    this.codeline = document.getElementById("curvegroup");
    this.curvecode = this.codeline.innerHTML;
    console.log(this.curvecode);

    this.outputxx1 = document.getElementById("xx1value").innerHTML;
    this.outputyy1 = document.getElementById("yy1value").innerHTML;
    this.curvestring = "T" + this.outputxx1 + "," + this.outputyy1 + " " + this.re;
    this.curvecode = this.curvecode.replace(this.re, this.curvestring);
    document.getElementById("curvegroup").innerHTML = this.curvecode;
    this.codeline = document.getElementById("curvegenerator").innerHTML;
    this.curvecode = this.codeline.innerHTML;
    this.curvecode = this.curvecode.replace(this.re, this.curvestring);
    document.getElementById("curvegenerator").innerHTML = this.curvecode;
              
    console.log(this.curvecode);
  }
  private Zit() {
    this.codeline = document.getElementById("curvegroup");
    this.curvecode = this.codeline.innerHTML;
    console.log(this.curvecode);
    this.curvestring = "z" + this.re;
    this.curvecode = this.curvecode.replace(this.re, this.curvestring);
    document.getElementById("curvegroup").innerHTML = this.curvecode;
    this.codeline = document.getElementById("curvegenerator").innerHTML;
    this.curvecode = this.codeline.innerHTML;
    this.curvecode = this.curvecode.replace(this.re, this.curvestring);
    document.getElementById("curvegenerator").innerHTML = this.curvecode;
              
    console.log(this.curvecode);
  }
  private doxx1() {
    this.slider = document.getElementById("svgxx1");
    this.output = document.getElementById("xx1value");
    this.output.innerHTML = this.slider.value;
    this.slider.oninput = function () {
      this.output.innerHTML = this.value;
    };
  }
  private doyy1() {
    this.slider = document.getElementById("svgyy1");
    this.output = document.getElementById("yy1value");
    this.output.innerHTML = this.slider.value;
    this.slider.oninput = function () {
      this.output.innerHTML = this.value;
    };
  }
  private doxx2() {
    this.slider = document.getElementById("svgxx2");
    this.output = document.getElementById("xx2value");
    this.output.innerHTML = this.slider.value;
    this.slider.oninput = function () {
      this.output.innerHTML = this.value;
    };
  }
  private doyy2() {
    this.slider = document.getElementById("svgyy2");
    this.output = document.getElementById("yy2value");
    this.output.innerHTML = this.slider.value;

    this.slider.oninput = function () {
      this.output.innerHTML = this.value;
    };
  }
  private doxx3() {
    this.slider = document.getElementById("svgxx3");
    this.output = document.getElementById("xx3value");
    this.output.innerHTML = this.slider.value;

    this.slider.oninput = function () {
      this.output.innerHTML = this.value;
    };
  }
  private doyy3() {
    this.slider = document.getElementById("svgyy3");
    this.output = document.getElementById("yy3value");
    this.output.innerHTML = this.slider.value;

    this.slider.oninput = function () {
      this.output.innerHTML = this.value;
    };
  }
  private doxx4() {
    this.slider = document.getElementById("svgxx4");
    this.output = document.getElementById("xx4value");
    this.output.innerHTML = this.slider.value;

    this.slider.oninput = function () {
      this.output.innerHTML = this.value;
    };
  }
  private doyy4() {
    this.slider = document.getElementById("svgyy4");
    this.output = document.getElementById("yy4value");
    this.output.innerHTML = this.slider.value;

    this.slider.oninput = function () {
      this.output.innerHTML = this.value;
    };
  }
       
  private svgmakepoly() {
    //var myshapes = (Math.svgmakefloor(Math.random() * 20);
    this.polycode = "";
    var myshapes = 1;
    console.log("myshapes" + myshapes);
    var k = Math.floor(myshapes);
    var j = 0;
    while (j < k) {
      j++;
      var mysvgpoints = (Math.floor(Math.random() * 10) + 3);
      console.log("mysvgpoints" + mysvgpoints);
      var i = 0;
      var n = Math.floor(mysvgpoints);
      var x = 0;
      var y = 0;
      var line = "";
      while (i < n) {
        i++;
        x = (Math.floor(Math.random() * 500) + 100);
        y = (Math.floor(Math.random() * 500) + 100);
        line = line + x + "," + y + " ";
      }
      var mycolor = (Math.floor(Math.random() * 359) + 1);
      var myfill = 'hsl(' + mycolor + ',100%,100%);';
      //var this.polycode=svgstartit();
      this.polycode = this.polycode + '<g><polygon class="draggable" fill="' + myfill + '" points="';
      this.polycode = this.polycode + line;
      this.polycode = this.polycode + '"></polygon></g>';
      //this.polycode=this.polycode+svgendit()
      document.getElementById("basement").innerHTML = this.polycode;
      this.setShape('#basement');
      //this.showData = this.basement;
      this.lockShape = true;
    }
    return this.polycode;
  };

  private svgmakequadratic() {
    //var myshapes = (Math.floor(Math.random() * 20);
    this.quadcode = "";
    var myshapes = 1;
    console.log("myshapes" + myshapes);
    var k = Math.floor(myshapes);
    var j = 0;
    while (j < k) {
      j++;
      var mysvgpoints = (Math.floor(Math.random() * 10) + 3);
      console.log("mysvgpoints" + mysvgpoints);
      var i = 0;
      var n = Math.floor(mysvgpoints);
      var x = 0;
      var y = 0;
      var line = "M ";
      x = (Math.floor(Math.random() * 500) + 100);
      y = (Math.floor(Math.random() * 500) + 100);
      line = line + x + "," + y + " ";
      while (i < n) {
        i++;
        line = line + "Q";
        x = (Math.floor(Math.random() * 500) + 100);
        y = (Math.floor(Math.random() * 500) + 100);
        line = line + x + "," + y + " ";
        x = (Math.floor(Math.random() * 500) + 100);
        y = (Math.floor(Math.random() * 500) + 100);
        line = line + x + "," + y + " ";
      }
      var mycolor = (Math.floor(Math.random() * 359) + 1);
      var myfill = 'hsl(' + mycolor + ',100%,100%);';
      //var this.quadcode=svgstartit();
      this.quadcode = this.quadcode + '<g><path class="draggable" fill="' + myfill + '" d="';
      this.quadcode = this.quadcode + line;
      this.quadcode = this.quadcode + 'z"></path></g>';
      //this.quadcode=this.quadcode+svgendit()
      document.getElementById("basement").innerHTML = this.quadcode;
      this.setShape('#basement');
      //this.showData = this.basement;
      this.lockShape = true;
    }
    return this.quadcode;
  };

  private svgmakebezier() {
    //var myshapes = (Math.floor(Math.random() * 20);
    this.bezcode = "";
    var myshapes = 1;
    console.log("myshapes" + myshapes);
    var k = Math.floor(myshapes);
    var j = 0;
    while (j < k) {
      j++;
      var mysvgpoints = (Math.floor(Math.random() * 10) + 3);
      console.log("mysvgpoints" + mysvgpoints);
      var i = 0;
      var n = Math.floor(mysvgpoints);
      var x = 0;
      var y = 0;
      var line = "M ";
      x = (Math.floor(Math.random() * 500) + 100);
      y = (Math.floor(Math.random() * 500) + 100);
      line = line + x + "," + y + " ";
      while (i < n) {
        i++;
        line = line + "c";
        x = (Math.floor(Math.random() * 500) + 100);
        y = (Math.floor(Math.random() * 500) + 100);
        line = line + x + "," + y + " ";
        x = (Math.floor(Math.random() * 500) + 100);
        y = (Math.floor(Math.random() * 500) + 100);
        line = line + x + "," + y + " ";
        x = (Math.floor(Math.random() * 500) + 100);
        y = (Math.floor(Math.random() * 500) + 100);
        line = line + x + "," + y + " ";
        x = (Math.floor(Math.random() * 500) + 100);
        y = (Math.floor(Math.random() * 500) + 100);
        line = line + x + "," + y + " ";
      }
      var mycolor = (Math.floor(Math.random() * 359) + 1);
      var myfill = 'hsl(' + mycolor + ',100%,100%);';
      //var this.bezcode=svgstartit();
      this.bezcode = this.bezcode + '<g><path class="draggable" fill="' + myfill + '" d="';
      this.bezcode = this.bezcode + line;
      this.bezcode = this.bezcode + 'z"></path></g>';
      document.getElementById("basement").innerHTML = this.bezcode;
      this.setShape('#basement');
      this.lockShape = true;
      
    }
    return this.bezcode;
  }


  private addcurve(kind) {
    
      if ((kind == 'm')||(kind == 'M')) {
        this.curvecode = kind +
          this.svgxx0 + ',' +
          this.svgyy0 + ' ';
        
      this.startmarker='<circle id="marker" fill="red" class="draggable" cx="'+this.svgxx0+'" cy="'+this.svgyy0+'0" r="30"></circle>'
      document.getElementById("basement").innerHTML = this.startmarker;
      this.setShape('#basement');
      this.lockShape = true;
      }
    
    
      else if ((kind == 'l')||(kind == 'L')) {
      this.curvecode = kind +
        this.svgxx4 + ',' +
        this.svgyy4 + ' ';
      }
        
        else if ((kind == 'c')||(kind == 'C')) {
        this.curvecode = kind +
          this.svgxx1 + ',' +
          this.svgyy1 + ' ' +
          this.svgxx2 + ',' +
          this.svgyy2 + ' ' +
          this.svgxx3 + ',' +
          this.svgyy3 + ' ';
      }
      else if ((kind == 'q')||(kind == 'Q')) {
        this.curvecode = kind +
          this.svgxx5 + ',' +
          this.svgyy5 + ' ' +
          this.svgxx6 + ',' +
          this.svgyy6 + ' ';
      }        

      else if ((kind == 's')||(kind == 'S')) {
        this.curvecode = kind +
          this.svgxx7 + ',' +
          this.svgyy7 + ' ' +
          this.svgxx8 + ',' +
          this.svgyy8 + ' ';
      }
      else if ((kind == 't')||(kind == 'T')) {
        this.curvecode = kind +
          this.svgxx9 + ',' +
          this.svgyy9 + ' ';
    }
      else if ((kind == 'z') || (kind == 'Z')) {
       this.codestorage = this.codestorage ;

        this.startmarker = "";
      this.showcurve =  this.mycurve + this.codestorage + this.myclose;
        //alert("end "+ this.showcurve);
        document.getElementById("basement").innerHTML = this.showcurve;
        this.setShape('#basement');
        this.lockShape = true;
        return this.curvecode;
    }
      this.codestorage = this.codestorage + this.curvecode;
      this.showcurve =  this.startmarker+ this.mycurve + this.codestorage + this.myclose;
      document.getElementById("basement").innerHTML = this.showcurve;
      this.setShape('#basement');
      this.lockShape = true;
        //alert(this.showcurve);

    return this.curvecode;

}
  private hide(kink) {
    var block1 = document.getElementById(kink);
    if (block1.style.visibility == "visible") {
      block1.style.visibility = "hidden";
      alert(kink + ": " + block1.style.visibility);
    }
  }

  private show(kink) {
    var block1 = document.getElementById(kink);
    if (block1.style.visibility == "hidden") {
      block1.style.visibility = "visible";
      alert(kink + ": " + block1.style.visibility);
    }
  }

private clearstorage(){
  this.codestorage = "";
   this.curvecode  = "";
  
}

  private zoomin() {
    this.zoomsize = this.layers;
    this.scale = 1;
  }

    private zoomout() {
    this.zoomsize = 1;
    this.scale = .03;
  }

  private curveit() {
if (this.randomsvgyy0==true){this.svgyy0=this.getRandom(-250, 250) ;}
if (this.randomsvgyy1==true){this.svgyy1=this.getRandom(-250, 250) ;}
if (this.randomsvgyy2==true){this.svgyy2=this.getRandom(-250, 250) ;}
if (this.randomsvgyy3==true){this.svgyy3=this.getRandom(-250, 250) ;}
if (this.randomsvgyy4==true){this.svgyy4=this.getRandom(-250, 250) ;}
if (this.randomsvgyy5==true){this.svgyy5=this.getRandom(-250, 250) ;}
if (this.randomsvgyy6==true){this.svgyy6=this.getRandom(-250, 250) ;}
if (this.randomsvgyy7==true){this.svgyy7=this.getRandom(-250, 250) ;}
if (this.randomsvgyy8==true){this.svgyy8=this.getRandom(-250, 250) ;}
if (this.randomsvgyy9==true){this.svgyy9=this.getRandom(-250, 250) ;}
if (this.randomsvgyy10==true){this.svgyy10=this.getRandom(-250, 250) ;}
if (this.randomsvgyy11==true){this.svgyy11=this.getRandom(-250, 250) ;}
if (this.randomsvgxx0==true){this.svgxx0=this.getRandom(-250, 250) ;}
if (this.randomsvgxx1==true){this.svgxx1=this.getRandom(-250, 250) ;}
if (this.randomsvgxx2==true){this.svgxx2=this.getRandom(-250, 250) ;}
if (this.randomsvgxx3==true){this.svgxx3=this.getRandom(-250, 250) ;}
if (this.randomsvgxx4==true){this.svgxx4=this.getRandom(-250, 250) ;}
if (this.randomsvgxx5==true){this.svgxx5=this.getRandom(-250, 250) ;}
if (this.randomsvgxx6==true){this.svgxx6=this.getRandom(-250, 250) ;}
if (this.randomsvgxx7==true){this.svgxx7=this.getRandom(-250, 250) ;}
if (this.randomsvgxx8==true){this.svgxx8=this.getRandom(-250, 250) ;}
if (this.randomsvgxx9==true){this.svgxx9=this.getRandom(-250, 250) ;}
if (this.randomsvgxx10==true){this.svgxx10=this.getRandom(-250, 250) ;}
if (this.randomsvgxx11==true){this.svgxx11=this.getRandom(-250, 250) ;}

  }
  private ccurveit() {
if (this.randomsvgyy1==true){this.svgyy1=this.getRandom(-100, 100) ;}
if (this.randomsvgyy2==true){this.svgyy2=this.getRandom(-100, 100) ;}
if (this.randomsvgyy3==true){this.svgyy3=this.getRandom(-250, 250) ;}
if (this.randomsvgxx1==true){this.svgxx1=this.getRandom(-100, 100) ;}
if (this.randomsvgxx2==true){this.svgxx2=this.getRandom(-100, 100) ;}
if (this.randomsvgxx3==true){this.svgxx3=this.getRandom(-250, 250) ;}

  }
  
  private qcurveit() {
if (this.randomsvgyy5==true){this.svgyy5=this.getRandom(-250, 250) ;}
if (this.randomsvgyy6==true){this.svgyy6=this.getRandom(-250, 250) ;}
if (this.randomsvgxx5==true){this.svgxx5=this.getRandom(-250, 250) ;}
if (this.randomsvgxx6==true){this.svgxx6=this.getRandom(-250, 250) ;}

  }
  
  private scurveit() {
if (this.randomsvgyy7==true){this.svgyy7=this.getRandom(-250, 250) ;}
if (this.randomsvgyy8==true){this.svgyy8=this.getRandom(-250, 250) ;}
if (this.randomsvgxx7==true){this.svgxx7=this.getRandom(-250, 250) ;}
if (this.randomsvgxx8==true){this.svgxx8=this.getRandom(-250, 250) ;}

  }
  
  private tcurveit() {
if (this.randomsvgyy9==true){this.svgyy9=this.getRandom(-250, 250) ;}
if (this.randomsvgxx9==true){this.svgxx9=this.getRandom(-250, 250) ;}
}

  private lineit() {
  if (this.randomsvgyy4==true){this.svgyy4=this.getRandom(-250, 250) ;}
if (this.randomsvgxx4==true){this.svgxx4=this.getRandom(-250, 250) ;}
  }
  
    private moveit() {
if (this.randomsvgyy0==true){this.svgyy0=this.getRandom(-250, 250) ;}
if (this.randomsvgxx0==true){this.svgxx0=this.getRandom(-250, 250) ;}
  }



}
